export const RETAILER_TYPE = "retailer";
